import React from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';

class LoadingDots extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    var dimensions = {
      width: this.props.dotSize,
      height: this.props.dotSize,
    };

    return (
      <div className={styles.spinner}>
        <div className={styles.bounce1} style={dimensions}></div>
        <div className={styles.bounce2} style={dimensions}></div>
        <div className={styles.bounce3} style={dimensions}></div>
      </div>
    );
  }
}

export default LoadingDots;